import { GetterTree } from 'vuex';
import { UsersState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<UsersState, RootState> = {
    /**
     * Check if user module is enabled.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    userModuleEnabled: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('users');
    },

    //check customer permissions

    /**
     * Check if user can create users.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canCreateUser: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('users.create');
    },

    /**
     * Get the active user.
     *
     * @param state
     * @param myGetters
     */
    activeUser: (state, myGetters) => {
        return myGetters.getUserById(state.activeUserId);
    },

    /**
     * Return the specified user.
     *
     * @param state
     */
    getUserById: (state) => (id: number) => {
        return state.users.find((user) => user.id === id);
    },

    /**
     * Return the users of a company.
     *
     * @param state
     */
    companyUsers: (state) => (companyId: number) => {
        return state.users.filter((user) => user.companies.find((company) => (company.id === companyId)));
    },

    /**
     * Check if user is in collection.
     *
     * @param state
     * @param myGetters
     */
    isUserLoaded: (state, myGetters) => (id: number): boolean => {
        return !!myGetters.getUserById(id);
    },
};
